// views/MainPage/ReferralPage/ReferralPage.tsx
import { useState, useEffect, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Referenced, ReferralCode } from '../../../Entities';
import Loading from '../../../components/common/Loading/Loading';
import { notify } from '../../../components/common/Toast/toastBridge';
import styles from '../authShared.module.css';
import { validateReferralCode } from '../../../utils/helpers';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ReferralPage = () => {
  const [referralCode, setReferralCode] = useState<ReferralCode>();
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const getReferencer = async () => {
      try {
        const referralCode: ReferralCode | null = await validateReferralCode();
        if (referralCode === null) {
          notify.error("Zvací odkaz je neplatný");
          navigate("/");
          return;
        }

        setReferralCode(referralCode);
        setLoading(false);
      } catch (error) {
        console.log(error);
        navigate('/');
      }
    };
    getReferencer();
  }, [navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!email) {
      notify.warning('Email je povinný');
      return;
    }
    if (!EMAIL_RE.test(email)) {
      notify.warning('Neplatný formát emailu');
      return;
    }

    try {
      setProcessing(true);
      await Referenced.sendRegEmail(email, referralCode!.code);
      setSuccess('Email byl úspěšně poslán.');
    } catch (error) {
      console.log(error);
      notify.error('Nepodařilo se odeslat email, zkuste prosím to později.');
    } finally {
      setProcessing(false);
    }
  };

  if (loading || !referralCode) return <Loading />;

  return (
    <div className={styles.authPage}>
      <div className={styles.container}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h1>{referralCode.referencer_name} Vás pozval</h1>
            <p className={styles.subtitle}>
              Pro registraci do Algapie zadejte prosím Váš email, na který vám dojdou informace
              a odkaz na registraci.
            </p>
          </div>

          {success ? (
            <>
              <div className={styles.success}>{success}</div>
              <button className={styles.btnGhost} onClick={() => navigate('/')}>
                Přejít na domovskou stránku
              </button>
            </>
          ) : (
            <form onSubmit={handleSubmit} className={styles.form}>
              <div className={styles.formGroup}>
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  className={styles.input}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="username"
                  placeholder="vas@email.cz"
                  disabled={processing}
                />
              </div>
              <button type="submit" className={styles.btnPrimary} disabled={processing}>
                {processing ? 'Odesílání...' : 'Zaslat email'}
              </button>
            </form>
          )}

          <div className={styles.altSection}>
            <p>Těšíme se na Vás!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralPage;
